import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, SxProps, Theme, Typography, useTheme } from "@mui/material"
import React, { useMemo } from "react"
import { TextBlockRenderer } from "../../../strapi/blockRenderer"
import { TextItemComponent, TextItemProps } from "./text-item"

export type TextItemListProps = {
    Items: TextItemProps[]
    Layout?: 'Standard' | 'Accordian' | null
    SlotProps?: {
        TextItem?: TextItemProps['SlotProps']
    }
}

const containerStyles = (theme: Theme): SxProps => ({
    width: '100%',
    height: '100%'
})

export const TextItemListComponent = ({ Items, SlotProps, Layout }: TextItemListProps) => {
    const theme = useTheme();
    const containerStyle = useMemo(() => containerStyles(theme), []);

    return (
        <Box sx={containerStyle}>
            {Layout === 'Accordian' ? (
                Items && Items.map((item, index) => (
                    <Accordion key={item.id}>
                        <AccordionSummary
                            aria-controls={`faq-${index}-content`}
                            id={`faq-${index}-header`}
                        >
                            <Typography fontWeight={'bold'} component="span">{item.Heading}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {item.Content && <Typography variant="body2" component={"div"}><TextBlockRenderer content={item.Content} /></Typography>}
                        </AccordionDetails>
                    </Accordion>
                ))
            ) : (
                <Stack direction='column' justifyContent='flex-start' alignItems='space-between' gap={2} sx={{ width: '100%', height: '100%' }}>
                    {Items && Items.map((item, index) => (
                        <TextItemComponent key={index} {...item} SlotProps={SlotProps?.TextItem} />
                    ))}
                </Stack>
            )}
        </Box>
    )
}